<template>
	<div class="">
		<h2>Мои классы</h2>
		<back></back>
		<ul class="uk-child-width-1-2@s uk-grid-match uk-flex-center" uk-grid>
			<li v-for="item in items" :key="item.id">
				<router-link :to="'/class/' + item.id">
					<div class="maincontent__item maincontent__item--class">
						<h2><strong>{{ item.title }}</strong></h2>
						<p v-if="item.teacher"><small><strong>Преподаватель:</strong><br>{{ item.teacher.name }}</small></p>
						<div v-html="item.desc"></div>
					</div>
				</router-link>
			</li>
		</ul>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
  export default {
    name: "classes",
    computed: {
			...mapGetters({
				items: 'student/classes'
			})
    }
  }
</script>